import { useEffect } from 'react';
import { articlesApi } from '@texas/api/endpoints/articlesApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';

export function useArticleAvailability(codes: string[]) {
  const { data, loading, error, refetch, set } = useApiResource(
    articlesApi.validateItemCodes,
  );
  useEffect(() => {
    set(null);
    if (!codes.length) return;
    void refetch(codes);
    return () => set(null);
  }, [codes, refetch, set]);
  return { data, loading, error, refetch, set };
}
